export default {
  loadedPageParams: false, // If page parameters have been successfully received
  loading: false, // if a resource is loading. should be set to false when loading is complete.
  loadingText: "", // Loading text below spinner. can be set to empty
  postLoadingText: "", // Post loading text. cam be set to empty. will automatically clear
  postLoadingAnimation: "", // Post loading animation. default is success post loading animation.
  loadingAnimationActive: false, // If the loading animation is currently active.
  postLoadingAnimationActive: false, // If the post loading animation is currently active.
  uiHeaderText: "", //Title text in the ui header
  uiHeaderBackActive: false //if ui header should show the back button
};
